import React from 'react';

import { instagramHash } from 'settings';

const InstagramView = () => (
  <iframe
    title="insta"
    className="instagram"
    src={`https://embedsocial.com/facebook_album/pro_hashtag/${instagramHash}`}
    width="100%"
    height="100%"
    frameBorder="0"
    marginHeight="0"
    marginWidth="0"
  />
);

export default InstagramView;
